import { useState, useEffect } from 'react'

/**
 * Les sites visibles par l'utilisateur — pour les écrans React du builder qui
 * RATTACHENT un contenu à un site : création d'un type de contenu, onglet
 * « Schéma » d'un type hérité sans site. Même source et même forme que le
 * sélecteur du panneau « Adresse » d'une page, qui s'en sert aussi : la
 * collection decoupled des groupes `site`, déjà filtrée par les droits.
 *
 * React et non rjBuild : ses trois consommateurs sont des écrans React du
 * builder qui alimentent un `<select>` contrôlé dans leur propre état ; une
 * source de données reactive-json n'atteint pas un composant React. Ce hook
 * ne crée pas de fetch de plus : il remplace la copie que portait le panneau.
 *
 * @returns {{sites: Array<{id: number, name: string}>, loading: boolean, error: boolean}}
 */
export const useBuilderSites = () => {
  const [sites, setSites] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false
    fetch('/decoupled-api/group/site/collection?display=decoupled', { credentials: 'include' })
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status))
        return res.json()
      })
      .then((payload) => {
        if (cancelled) return
        // Enveloppe Syncable pour qui peut écrire le site, objet plat sinon :
        // les deux formes cohabitent selon le lecteur (cf. Navigation.yaml).
        const items = (Array.isArray(payload) ? payload : [])
          .map(item => item?.data ?? item)
          .filter(d => d && d.id != null)
          .map(d => ({ id: Number(d.id), name: d.name || `Site ${d.id}` }))
        items.sort((a, b) => a.name.localeCompare(b.name, 'fr'))
        setSites(items)
      })
      .catch(() => { if (!cancelled) setError(true) })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [])

  return { sites, loading, error }
}
